function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormLabel, FormSelect } from '../../../style/export';

export default function AreaAttributesEditor(_ref, _ref2) {
    var element = _ref.element,
        onUpdate = _ref.onUpdate,
        attributeFormData = _ref.attributeFormData,
        state = _ref.state,
        rest = _objectWithoutProperties(_ref, ['element', 'onUpdate', 'attributeFormData', 'state']);

    var translator = _ref2.translator;

    var scene = state.scene;
    var floors = scene.get('floors');
    var floorID = element.floorID ? element.floorID : floors.first().id;
    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            { className: 'floor-record' },
            React.createElement(
                'div',
                { className: 'floor-label' },
                React.createElement(
                    FormLabel,
                    null,
                    translator.t("Floor")
                )
            ),
            React.createElement(
                FormSelect,
                { value: floorID, onChange: function onChange(event) {
                        return onUpdate('floorID', event.target.value);
                    } },
                floors.toArray().map(function (floor, index) {
                    return React.createElement(
                        'option',
                        { key: index, value: floor.id },
                        floor.name
                    );
                })
            )
        )
    );
}

AreaAttributesEditor.propTypes = {
    element: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onValid: PropTypes.func,
    attributeFormData: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired
};

AreaAttributesEditor.contextTypes = {
    translator: PropTypes.object.isRequired
};